import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-ink text-cream/85 py-10" data-testid="footer">
      <div className="max-w-6xl mx-auto px-5 md:px-8 grid md:grid-cols-3 gap-6 items-start">
        <div>
          <div className="font-heading text-xl text-cream">Светлана Белавская</div>
          <div className="text-sm text-cream/55 mt-1">Психолог · КПТ-практик</div>
        </div>
        <div className="font-heading italic text-cream/80 text-lg">
          «Хорошо там, где я&nbsp;есть.»
        </div>
        <div className="text-sm text-cream/55 md:text-right">
          belavskaya.com
          <div className="mt-1">
            © {new Date().getFullYear()} · Сайт создан с{' '}
            <a href="https://flyai.by" target="_blank" rel="noreferrer" className="text-gold hover:text-cream transition-colors" data-testid="footer-flyai">
              FlyAI.by
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
